module.exports = {
  id: 'attachments',
  type: 'attachments',
  icon: 'paperclip',
  title: 'ProjectDetails.attachments',
  classes: {
    attachment: {
      fileTypes: ['jpg', 'jpeg', 'png', 'tif', 'bmp', 'zip', 'constructionInfo', 'pts', '3ox', 'html', 'scanInfo', 'dentalProject', 'dentalCAD', 'dentalCADscreenshot', 'articulatorSettings', 'modelInfo', 'inf']
    },
  }
};
